export const phoneNumberTypes = {
  HEALTHPLANPROVIDEDPHONENUMBER: 'HEALTHPLANPROVIDEDPHONENUMBER',
  PHONENUMBER: 'PHONENUMBER',
  LANDLINEPHONENUMBER: 'LANDLINEPHONENUMBER',
};
